export default __webpack_public_path__ + "static/media/driver_license.11cb91b4.png";